export const FourthItem = ({isShownLetters, ...props}) => (
<svg {...props} viewBox="0 0 98 77" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M92.6953 10L26.3213 76.374" stroke="white"/>
<path d="M26 10L92.374 76.374" stroke="white"/>
<circle cx="59.4702" cy="51.4702" r="2.47019" fill="white"/>
<circle cx="59.4702" cy="35.4702" r="2.47019" fill="white"/>
<circle cx="51.4693" cy="43.4702" r="2.47019" transform="rotate(90 51.4693 43.4702)" fill="white"/>
<circle cx="67.4693" cy="43.4702" r="2.47019" transform="rotate(90 67.4693 43.4702)" fill="white"/>
{
    isShownLetters && (
        <g>
            <g filter="url(#filter0_b_2171_3226)">
            <path d="M56.8278 19.592L52.8678 13.4H54.7758L57.9618 18.458L61.3638 13.4H63.1998L58.9878 19.466L63.3618 26H61.4538L57.8898 20.636L54.4697 26H52.6338L56.8278 19.592Z" fill="white"/>
            </g>
            <g filter="url(#filter1_b_2171_3226)">
            <path d="M29.0902 36.4H30.7102V47.56H37.0642V36.4H38.6842V47.56H40.3042V51.34H38.7922V49H29.0902V36.4Z" fill="white"/>
            </g>
            <g filter="url(#filter2_b_2171_3226)">
            <path d="M86.4776 43.834C86.1536 44.05 85.7156 44.236 85.1636 44.392C84.6236 44.548 83.9816 44.626 83.2376 44.626C82.0016 44.626 81.0416 44.374 80.3576 43.87C79.6736 43.354 79.3316 42.622 79.3316 41.674V36.4H80.9516V40.918C80.9516 41.35 81.0116 41.716 81.1316 42.016C81.2636 42.304 81.4376 42.538 81.6536 42.718C81.8816 42.898 82.1576 43.024 82.4816 43.096C82.8056 43.168 83.1656 43.204 83.5616 43.204C84.1376 43.204 84.6776 43.15 85.1816 43.042C85.6856 42.922 86.1176 42.742 86.4776 42.502V36.4H88.0976V49H86.4776V43.834Z" fill="white"/>
            </g>
            <g filter="url(#filter3_b_2171_3226)">
            <path d="M51.1918 60.4H52.8118V71.56H57.1858V60.4H58.8058V71.56H63.1798V60.4H64.7998V73H51.1918V60.4Z" fill="white"/>
            </g>
        </g>
    )
}
<g filter="url(#filter4_b_2171_3226)">
<path d="M1.46888 8L6.50888 0.799999H8.22088V7.632H9.88488V8.912H8.22088V12H6.87688V8.912H1.46888V8ZM6.87688 2.368L3.26088 7.632H6.87688V2.368ZM12.1506 11.136C12.1506 10.848 12.22 10.6027 12.3586 10.4C12.508 10.1973 12.7853 10.096 13.1906 10.096C13.596 10.096 13.8733 10.1973 14.0226 10.4C14.172 10.6027 14.2466 10.848 14.2466 11.136C14.2466 11.4133 14.172 11.6533 14.0226 11.856C13.8733 12.0587 13.596 12.16 13.1906 12.16C12.7853 12.16 12.508 12.0587 12.3586 11.856C12.22 11.6533 12.1506 11.4133 12.1506 11.136Z" fill="white"/>
</g>
<defs>
<filter id="filter0_b_2171_3226" x="48.6328" y="9.40002" width="18.7285" height="20.6" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feGaussianBlur in="BackgroundImageFix" stdDeviation="2"/>
<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2171_3226"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2171_3226" result="shape"/>
</filter>
<filter id="filter1_b_2171_3226" x="25.0898" y="32.3999" width="19.2148" height="22.9402" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feGaussianBlur in="BackgroundImageFix" stdDeviation="2"/>
<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2171_3226"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2171_3226" result="shape"/>
</filter>
<filter id="filter2_b_2171_3226" x="75.332" y="32.3999" width="16.7656" height="20.6001" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feGaussianBlur in="BackgroundImageFix" stdDeviation="2"/>
<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2171_3226"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2171_3226" result="shape"/>
</filter>
<filter id="filter3_b_2171_3226" x="47.1914" y="56.3999" width="21.6074" height="20.6001" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feGaussianBlur in="BackgroundImageFix" stdDeviation="2"/>
<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2171_3226"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2171_3226" result="shape"/>
</filter>
<filter id="filter4_b_2171_3226" x="-2.53125" y="-3.19995" width="20.7773" height="19.36" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feGaussianBlur in="BackgroundImageFix" stdDeviation="2"/>
<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2171_3226"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2171_3226" result="shape"/>
</filter>
</defs>
</svg>

)